import { Flex, Text, TextButton } from '@zillow/constellation';
import React, { useCallback } from 'react';
import numberUtils from 'app/shared/utils/numberUtils';
import { trackEvent } from 'app/shared/utils/analytics/trackEvent';
import { Area, ComposedChart, Line, XAxis, YAxis } from 'recharts';
import * as S from './styles';

import type { Market } from 'app/shared/types/Market';
import type { GaEventObjectType } from 'app/shared/types/GaEventObjectType';

const MarketPreview: React.FunctionComponent<
    Market & { isSmallScreen: boolean; resourceId: string; gaEvent: GaEventObjectType }
> = (props) => {
    const { name, medianRent, prices, url, isSmallScreen, resourceId, gaEvent } = props;
    const exploreMarket = useCallback(() => trackEvent({ ...gaEvent, label: resourceId }), []);
    return prices ? (
        <S.Link href={url} onClick={exploreMarket}>
            <S.Card cardType="secondary" padding={isSmallScreen ? 'xs' : 'sm'} isSmallScreen={isSmallScreen} key={name}>
                <Text as="p" fontType="bodySmallHeading">
                    {name}
                </Text>
                <Text as="p" fontType="bodySmall">
                    {numberUtils.asCurrency(medianRent)}
                </Text>
                <Flex display="flex" alignItems="center" justifyContent="center" flex="1">
                    <ComposedChart
                        width={isSmallScreen ? 120 : 140}
                        height={60}
                        data={prices.map((price) => {
                            return { price };
                        })}
                    >
                        <defs>
                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#50E3FF" stopOpacity={0.25} />
                                <stop offset="100%" stopColor="#FFBFAD" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <XAxis dataKey="time" tick={false} hide={true} />
                        <YAxis tick={false} hide={true} domain={['auto', 'auto']} />
                        <Line
                            type="monotone"
                            strokeLinecap="round"
                            strokeWidth={2}
                            dataKey="price"
                            stroke="#50E3FF"
                            dot={false}
                            legendType="none"
                        />
                        <Area type="monotone" dataKey="price" strokeWidth={2} fillOpacity={1} fill="url(#colorUv)" />
                    </ComposedChart>
                </Flex>
                <TextButton fontType="bodySmall">Explore market</TextButton>
            </S.Card>
        </S.Link>
    ) : null;
};

export default MarketPreview;
